import { Component, HostListener } from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-modal-alerta',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './modal-alerta.component.html',
  styleUrl: './modal-alerta.component.scss'
})
export class ModalAlertaComponent {

  public msg: string;
  public requestId: string;
  public tipo: string;

  constructor(private bsModalRef: BsModalRef) {}

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.close();
  }

  close() {
    this.bsModalRef.hide();
  }

}
